import ssrsReportViewer from './ssrsReportViewer';
import {showErrorNotification, showSuccessNotification} from '../global/notifications';
import {openCloseWindow, windowTriggers} from '../global/kendoWindows';
import dynamicKendoGrid from './dynamicKendoGrid';

let $companySelect;
let k_companySelect;
let $jobAutoComplete;
let $pmSelect;
let $departmentSelect;
let $paramPane;
let f_self;

export default function () {
    f_self = () => {
        $paramPane = $('#paramPane');
        if ($paramPane.length) {
            //Set General Values
            $companySelect = $('[data-type="company"]');
            $jobAutoComplete = $('[data-type="job"]');
            $pmSelect = $('[data-type="ProjectManager"]');
            $departmentSelect = $('[data-type="department"]');
            //Remove Wrong Defaults
            removeDefaultValue();

            //Setup Events
            if ($companySelect.length) {
                k_companySelect = $companySelect.data('kendoDropDownList');
                attachCompanySelectEvent();
            }
            if ($jobAutoComplete.length) {
                setJobRestriction();
            }
            if ($pmSelect.length) {
                setPmRestriction();
            }
            if ($departmentSelect.length) {
                setDepartmentRestriction();
            }

            attachJobFieldEvents();

            attachGridEvents($('.js-lookup-grid-btn'));

            attachDefaultEvents($('#saveDefaults'), $('#clearParams'), $('#restoreDefaults'));

            attachRunReportEvent();
        }

        if ($('#viewReport:visible').length) {
            ssrsReportViewer();
        }
    };
    f_self();
}

const attachCompanySelectEvent = () => {
    if ($jobAutoComplete.length || $pmSelect.length) {
        $companySelect.change(function () {
            $jobAutoComplete.each(function (index, ele) {
                let k_jobAutoComplete = $(ele).data('kendoAutoComplete');
                if (k_jobAutoComplete) {
                    k_jobAutoComplete.dataSource.read();
                }
            });

            $pmSelect.each(function (index, ele) {
                let k_pmSelect = $(ele).data('kendoDropDownList');
                if (k_pmSelect) {
                    k_pmSelect.dataSource.read();
                }
            });

            $departmentSelect.each(function (index, ele) {
                let k_departmentSelect = $(ele).data('kendoDropDownList');
                if (k_departmentSelect) {
                    k_departmentSelect.dataSource.read();
                }
            });
        });
    }
};

const setJobRestriction = () => {
    $jobAutoComplete.each(function (index, ele) {
        let k_jobAutoComplete = $(ele).data('kendoAutoComplete');
        if (k_jobAutoComplete) {
            let kendoOptions = k_jobAutoComplete.dataSource.transport.options;

            if (kendoOptions.read) {
                kendoOptions.read.data = function (data) {
                    let company = 0;

                    if (k_companySelect) {
                        company = k_companySelect.value();
                    }
                    data.company = company;
                    return data;
                };
            }
        }
    });
};

const setPmRestriction = () => {
    $pmSelect.each(function (index, ele) {
        let k_pmSelect = $(ele).data('kendoDropDownList');
        if (k_pmSelect) {
            let kendoOptions = k_pmSelect.dataSource.transport.options;

            if (kendoOptions.read) {
                kendoOptions.read.data = function (data) {
                    let company = 0;

                    if (k_companySelect) {
                        company = k_companySelect.value();
                    }
                    data.company = company;
                    return data;
                };
            }
        }
    });
};

const setDepartmentRestriction = () => {
    $departmentSelect.each(function (index, ele) {
        let k_departmentSelect = $(ele).data('kendoDropDownList');
        if (k_departmentSelect) {
            let kendoOptions = k_departmentSelect.dataSource.transport.options;

            if (kendoOptions.read) {
                kendoOptions.read.data = function (data) {
                    let company = 0;

                    if (k_companySelect) {
                        company = k_companySelect.value();
                    }
                    data.company = company;
                    return data;
                };
            }
        }
    });
};

const attachRunReportEvent = function () {
    let $runReportButton = $('#runReport'), $reportViewer = $('#reportViewer');

    if ($runReportButton.length && $reportViewer.length) {
        $runReportButton.click(function () {
            if (!validateForm()) return;
            $('#loading').show();
            $runReportButton.hide();

            let category = $('#Categories').data('kendoDropDownList').value();
            let reportName = $('#ReportList').data('kendoDropDownList').value();

            $reportViewer.load(encodeURI(`/Reporting/Ssrs/RunReport?category=${category}&reportName=${reportName}&paramString=${getParamString()}`), function () {
                ssrsReportViewer();
            });
        });
    }
};

export const getParamString = (forDefaults) => {
    let paramString = '';
    let $params = $paramPane.find('input');
    $params.each(function (index, ele) {
        let id = ele.id, thisEle = $(ele), dataType = thisEle.attr('data-type'), paramValue = ele.value;

        if (id && paramValue !== null && (!forDefaults || !ele.hidden)) {
            if (paramString.length) {
                paramString += ',';
            }
            paramString += `${id}:`;
            if (dataType === 'YesNo') {
                paramString += `${thisEle.prop('checked') ? 'Y' : 'N'}`;
            } else if (dataType === 'job') {
                if (!forDefaults) {
                    paramString += `${ele.value.substring(0, ele.value.indexOf('.') + 1)}`;
                } else {
                    paramString += ele.value;
                }
            } else if (dataType === 'ProjectManager' && ele.value === '0') {
                paramString = paramString.substr(0, paramString.length - (id.length + 1) - 1);
            } else if (dataType === 'MonthPick') {
                let tempValue = ele.value.split('/').join('/1/');
                if (!isNaN(new Date(tempValue).getTime())) {
                    paramString += tempValue;
                }
            } else {
                paramString += `${ele.value}`;
            }
        }
    });

    return paramString;
};

const validateForm = () => {
    let $requiredResponses = $paramPane.find('[data-required=True]'), validForm = true;
    $('.fieldValidationError').removeClass('fieldValidationError');
    $requiredResponses.each(function (index, ele) {
        let id = ele.id, thisEle = $(ele), dataType = thisEle.attr('data-type');
        if (id) {
            let thisValue = ele.value;
            if (dataType !== 'YesNo' && (thisValue === null || thisValue.toString().length === 0 || Number(thisValue) === -1)) {
                validForm = false;
                thisEle.parent().addClass('fieldValidationError');
            }
        }
    });

    return validForm;
};

const removeDefaultValue = () => {
    let $monthPickers = $('[data-type=MonthPick]');

    if ($monthPickers.length) {
        $monthPickers.each(function (index, monthPicker) {
            let k_monthPicker = $(monthPicker).data('kendoDatePicker');
            if (k_monthPicker) {
                k_monthPicker.value(k_monthPicker.value() || '');
            }
        });
    }
};

const attachJobFieldEvents = () => {
    let $jobFields = $('[data-type="job"]');

    if ($jobFields.length > 1) {
        $($jobFields[1]).focus(function (e) {
            if (e.originalEvent) {
                $(this).data('kendoAutoComplete').value($($jobFields[0]).data('kendoAutoComplete').value());
            } else {
                $(document).focus();
            }
        });
    }
};

const attachDefaultEvents = ($saveDefaults, $clearParams, $restoreDefaults) => {
    if ($saveDefaults.length) {
        $saveDefaults.unbind('click');
        $saveDefaults.click(function () {
            let data = {
                reportName: $('#ReportList').data('kendoDropDownList').value(), paramString: getParamString(true)
            };
            $.post('/Reporting/Ssrs/SaveDefaults', data)
                .then((response) => {
                    if (response) {
                        showSuccessNotification('Parameters Saved!');
                        //Reload Params section
                        $paramPane.load('/Reporting/Ssrs/ParamPane', data, function () {
                            f_self();
                            $(document).trigger('on:PageUpdate');
                        });
                    } else {
                        showErrorNotification('Error saving defaults');
                        console.error('Default could not be saved');
                    }
                });
        });
    }

    if ($clearParams) {
        $clearParams.unbind('click');
        $clearParams.click(function () {
            let $params = $paramPane.find('input');
            $params.each(function (index, ele) {
                let $thisEle = $(ele), dataType = $thisEle.attr('data-type');
                if (dataType === 'YesNo') {
                    $thisEle.prop('checked', false);
                } else if (dataType === 'company' || dataType === 'list' || dataType === 'ProjectManager') {
                    $thisEle.data('kendoDropDownList').select(0);
                } else if (dataType === 'job' || dataType === 'ProjectManager') {
                    $thisEle.data('kendoAutoComplete').value('');
                } else if (dataType === 'MonthPick' || dataType === 'DatePick') {
                    $thisEle.data('kendoDatePicker').value('');
                } else {
                    $thisEle.val('');
                }
                // Trigger form elements change event, for the function that updates status indicators
                $thisEle.trigger("change");
            });
        });
    }

    if ($restoreDefaults.length) {
        $restoreDefaults.unbind('click');
        $restoreDefaults.click(function () {
            $('#ReportList').change();
        });
    }
};

const attachGridEvents = ($gridIcons) => {
    if ($gridIcons.length) {
        $gridIcons.click(function () {
            let $self = $(this), gridSproc = $self.data('grid-sproc'), gridParams = $self.data('grid-params');
            let paramString = '';
            let paramArray = gridParams.split(',');
            for (let paramSet of paramArray) {
                let key = paramSet.split('=')[0];
                let value = paramSet.split('=')[1];
                let $paramEle = $(`#${value}`);

                value = $paramEle.val();

                if (paramString.length) {
                    paramString += ',';
                }
                paramString += `${key}:${value}`;
            }
            dynamicKendoGrid($('#lookupGrid'), gridSproc, paramString, $self.data('for-param'));
        });

        windowTriggers();
        openCloseWindow();
    }
};